import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./Users/userSlice";
import auctionSlice from "./Auctions/auctionSlice";
import { auctionReducer } from "./Auctions/auctionReducer";
import loaderSlice from "./Loader/loaderSlice";
import notificationSlice from "./Notifications/notificationSlice";
import cmsSlice from "./cms/cmsSlice";
import { authApi } from "./api/stoxAuthApi";
import common from "./api/common";
import favoritesReducer from './Favourites/favouritesSlice';

const rootReducer = combineReducers({
  auth: userSlice,
  games: auctionReducer,
  gamesSlice: auctionSlice,
  loader: loaderSlice,
  notifications: notificationSlice,
  cms: cmsSlice,
    favorites: favoritesReducer,
  //stox start
  [authApi.reducerPath]: authApi.reducer,
  common,

  // stox end
});

export default rootReducer;
